import FilterPanelFilterGroup from 'components/Common/FilterPanel/FilterPanelFilterGroup'
import CounterInput from 'components/Common/Form/Input/CounterInput'
import { EnabledFilters } from 'components/Search/type'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const InputGroup = styled(Group)`
  margin-top: ${rem(16)};
`

interface RoomFilterGroupProps {
  loading?: boolean
  filters: App.OfferListFilters
  enabledFilters: EnabledFilters
  onBedroomsChange: (value: number) => void
  onBedsChange: (value: number) => void
  onBathroomsChange: (value: number) => void
}

function RoomFilterGroup({
  loading,
  filters,
  enabledFilters,
  onBedroomsChange,
  onBedsChange,
  onBathroomsChange,
}: RoomFilterGroupProps) {
  return (
    <FilterPanelFilterGroup
      loading={loading}
      title="Rooms"
    >
      <InputGroup direction="vertical" gap={12}>
        {enabledFilters.bedrooms && (
          <CounterInput
            name="bedroomsEq"
            defaultValue={filters.bedroomsEq ?? 0}
            onChange={onBedroomsChange}
            min={0}
            max={10}
            label="Bedrooms"
            direction="horizontal"
            tabletDirection="horizontal"
          />
        )}
        {enabledFilters.beds && (
          <CounterInput
            name="bedsEq"
            defaultValue={filters.bedsEq ?? 0}
            onChange={onBedsChange}
            min={0}
            max={10}
            label="Beds"
            direction="horizontal"
            tabletDirection="horizontal"
          />
        )}
        {enabledFilters.bathrooms && (
          <CounterInput
            name="bathroomsEq"
            defaultValue={filters.bathroomsEq ?? 0}
            onChange={onBathroomsChange}
            min={0}
            max={10}
            label="Bathrooms"
            direction="horizontal"
            tabletDirection="horizontal"
          />
        )}
      </InputGroup>
    </FilterPanelFilterGroup>
  )
}

export default RoomFilterGroup
